import { useState } from "react";
import PlusIcon from "../../assets/icons/PlusIcon";
import Pill from "./Pill";

const PillInput = ({
  placeholder,
  className,
  iconClassName,
  onBlur,
  onSubmit
}: {
  placeholder?: string;
  className?: string;
  iconClassName?: string;
  onBlur: () => void;
  onSubmit: (value: string) => void;
}) => {
  const [value, setValue] = useState("");

  const handleSubmit = () => {
    onSubmit(value);
    onBlur();
  };

  return (
    <>
      <Pill
        className={
          "flex items-center justify-center gap-3 !rounded-xl py-1 pl-4 " +
          className
        }
      >
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={e => setValue(e.target.value)}
          className={
            "w-40 bg-transparent focus:border-none focus:outline-none " +
            className
              ?.split(" ")
              .filter(c => c.includes("text"))
              .map(c => `placeholder:${c.replace("!", "")}`)
              .join(" ")
          }
          onBlur={onBlur}
          onKeyDown={e => {
            if (e.key === "Enter") handleSubmit();
            else if (e.key === "Escape") onBlur();
          }}
          autoFocus
        />
        <PlusIcon
          clickEvent={handleSubmit}
          className={"mr-2 " + iconClassName}
        />
      </Pill>
    </>
  );
};
export default PillInput;
